
<span class="loader" 
[style.--scale-loader]=" width / 48"
[style.--loaderThickness]=" thickness + 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>